import request from '@/utils/request'

// 查询操作价格分页
export function pageOperationPrice(params) {
  return request({
    url: '/cloudplant/operationPrice/page',
    method: 'post',
    params: params
  })
}

// 查询操作价格列表
export function listOperationPrice(query) {
  return request({
    url: '/cloudplant/operationPrice/list',
    method: 'get',
    params: query
  })
}

// 新增操作价格
export function addOperationPrice(data) {
  return request({
    url: '/cloudplant/operationPrice/add',
    method: 'post',
    data: data
  })
}

// 修改操作价格
export function updateOperationPrice(data) {
  return request({
    url: '/cloudplant/operationPrice/edit',
    method: 'post',
    data: data
  })
}

// 删除操作价格
export function delOperationPrice(data) {
  return request({
    url: '/cloudplant/operationPrice/delete',
    method: 'post',
    data: data
  })
}
